import React, { useMemo } from 'react';
import './sizeArray.scss'
import SizeBtn from '../../LeftWorkArea/LeftWorkSize/SizeBtn';
import { useProductSizes } from '../../LeftWorkArea/LeftWorkSize/useProductSizes';

export type Size = {
    size: string,
    label: string
}

interface ISizeArray {
    sizes: Size[],
    selectedSize?: Size
    handleSelectedSize:(size:Size)=>void
}

export const SizeArray = (props: ISizeArray) => {
    const { sizes, selectedSize, handleSelectedSize } = props;

    const renderSizes = useMemo(
        () =>
            sizes.map(item => (
                <SizeBtn
                    key={item.size}
                    color={''}
                    title={item.label}
                    active={
                        selectedSize?.size === item.size
                    }
                    handler={()=>{
                        handleSelectedSize(item)
                    }}
                />
            )),
        [handleSelectedSize,selectedSize, sizes],
    )

    return <div className='size-array'>{renderSizes}</div>
}